/**
 * plugins/webfontloader.js
 *
 * webfontloader documentation: https://github.com/typekit/webfontloader
 */

export async function loadFonts() {
  console.log("fontロード");
  const webFontLoader = await import(/* webpackChunkName: "webfontloader" */ "webfontloader");

  webFontLoader.load({
    google: {
      families: ["Noto Sans Japanese", "Noto Sans CJK JP", "NotoSansCJKjp"],
    },
  });
}
